import { methods as methodsApi } from '@afosto/fulfilment/api/Methods';

const fetchShippingMethod = async methodId => {
  try {
    const response = await methodsApi.getShippingMethod(methodId);
    const { data = {} } = response;

    return data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export default fetchShippingMethod;
